import { useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Dropdown from 'react-bootstrap/Dropdown';
import { List } from 'react-bootstrap-icons';
import './PageTabs.css';

function PageTabs({ tabs }) {
  const [activeKey, setActiveKey] = useState(tabs[0].key);
  const activeTab = tabs.find(tab => tab.key === activeKey) || tabs[0];

  return (
    <>
      <div className="mobile-page-menu d-md-none">
        <Dropdown onSelect={(key) => key && setActiveKey(key)}>
          <Dropdown.Toggle
            id="mobile-page-menu-toggle"
            variant="outline-secondary"
            className="mobile-page-menu-toggle"
            aria-label={`Current page: ${activeTab.title}. Open page menu`}
          >
            <span className="mobile-page-menu-label">
              <List aria-hidden="true" />
              {activeTab.title}
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {tabs.map(tab => (
              <Dropdown.Item
                key={tab.key}
                eventKey={tab.key}
                active={tab.key === activeKey}
              >
                {tab.title}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <Tabs
        activeKey={activeKey}
        onSelect={(key) => key && setActiveKey(key)}
        id="page-tabs"
        className="mb-3 d-none d-md-flex"
      >
      {tabs.map(tab => (
        <Tab key={tab.key} eventKey={tab.key} title={tab.title}>
          {tab.content}
        </Tab>
      ))}
      </Tabs>
    </>
  );
}

export default PageTabs;